import authService from "./authService";
import SecureCookieManager from '../utils/secureCookie';

const BASE_URL = process.env.REACT_APP_API_URL;

function getToken() {
    return SecureCookieManager.getAuthToken();
}




export async function fetchSurveys() {
  try {
    
    const res = await authService.apiCall(`${BASE_URL}/surveys/all`, {
      method: 'GET',
     
    });
    if (!res.ok) throw new Error('Failed to fetch surveys');
    return await res.json();
  } catch (error) {
    throw new Error('Error in fetchSurveys');
  }
}

export async function createSurvey(title: string) {
  try {
   
    const res = await authService.apiCall(`${BASE_URL}/surveys`, {
      method: 'POST',
     
      body: JSON.stringify({ title }),
    });
    if (!res.ok) throw new Error('Failed to create survey');
    return await res.json();
  } catch (error) {
    throw new Error('Error in createSurvey');
  }
}

export async function fetchCategories() {
  try {
    
    const res = await authService.apiCall(`${BASE_URL}/question-categories/all`, {
      method: 'GET',
      
    });
    if (!res.ok) throw new Error('Failed to fetch categories');
    return await res.json();
  } catch (error) {
    throw new Error('Error in fetchCategories');
  }
}

export async function updateCategorySurvey(categoryId: string, surveyId: string) {
  try {
 
    const res = await authService.apiCall(`${BASE_URL}/question-categories/${categoryId}`, {
      method: 'PATCH',
      
      body: JSON.stringify({ surveyId }),
    });
    if (!res.ok) throw new Error('Failed to update category');
    return await res.json();
  } catch (error) {
    throw new Error('Error in updateCategorySurvey');
  }
}

export async function cloneCategory(en_name: string, ar_name: string, surveyId: string) {
  try {
   
    const res = await authService.apiCall(`${BASE_URL}/question-categories`, {
      method: 'POST',
   
      body: JSON.stringify({ en_name, ar_name, surveyId }),
    });
    if (!res.ok) throw new Error('Failed to clone category');
    return await res.json();
  } catch (error) {
    throw new Error('Error in cloneCategory');
  }
}

export async function fetchAllQuestions() {
  try {
   
    const res = await authService.apiCall(`${BASE_URL}/questions`, {
      method: 'GET',
    
    });
    if (!res.ok) throw new Error('Failed to fetch questions');
    const json = await res.json();
    return Array.isArray(json) ? json : json.data || [];
  } catch (error) {
    throw new Error('Error in fetchAllQuestions');
  }
}

export async function fetchQuestionsByCategory(categoryId: string) {
  try {
   
    const res = await authService.apiCall(`${BASE_URL}/questions/by-category/${categoryId}`, {
      method: 'GET',
   
    });
    if (!res.ok) throw new Error('Failed to fetch category questions');
    return await res.json();
  } catch (error) {
    throw new Error('Error in fetchQuestionsByCategory');
  }
}

export async function updateQuestionCategory(questionId: string, categoryId: string | null) {
  try {
   
    const res = await authService.apiCall(`${BASE_URL}/questions/${questionId}`, {
      method: 'PATCH',
    
      body: JSON.stringify({ questionCategoryId: categoryId }),
    });
    if (!res.ok) throw new Error('Failed to update question');
    return await res.json();
  } catch (error) {
    throw new Error('Error in updateQuestionCategory');
  }
}


export async function linkCategoryToSurvey(categoryId: string, surveyId: string) {
 
  const res = await authService.apiCall(`${BASE_URL}/surveys/${surveyId}/categories`, {
    method: 'POST',
   
    body: JSON.stringify({ categoryId }),
  });
  if (!res.ok) throw new Error('Failed to link category to survey');
  return await res.json();
}

export async function unlinkCategoryFromSurvey(categoryId: string, surveyId: string) {
 
  const res = await authService.apiCall(`${BASE_URL}/surveys/${surveyId}/categories/${categoryId}`, {
    method: 'DELETE',
   
  });
  if (!res.ok) throw new Error('Failed to unlink category from survey');
  return await res.json();
}